import { memo, useState } from 'react'
import { useTranslation } from 'react-i18next'

import translationKeys from '@translationKeys'
import { Nullable } from '@types'

import CustomPopover, { CustomPopoverProps } from '@components/CustomPopover'
import InputWithTitleSection from '@components/InputWithTitleSection'

import { PopoverInner } from '../ShortlistProfileButton/index.styles'

interface EditNotePopoverProps {
  anchor: CustomPopoverProps['anchor']
  setAnchor: (event: Nullable<React.MouseEvent<HTMLElement>>, data?: { profileId: number; note: string }) => void
  profileNoteData: Nullable<{ note?: string; profileId?: number }>
  deleteNoteHandler: (cb?: () => void) => void
  setConfirmExitPopupCloseAction: (cb: { close: () => void }) => void
  updateNote: (data: { id: number; data: { note: string } }) => void
}

const EditNotePopover = ({
  anchor,
  setAnchor,
  profileNoteData,
  deleteNoteHandler,
  setConfirmExitPopupCloseAction,
  updateNote,
}: EditNotePopoverProps) => {
  const { t } = useTranslation()
  const [localEditNoteValue, setLocalEditNoteValue] = useState<string>(profileNoteData?.note || '')

  const handleClose = () => {
    const edited = profileNoteData?.note !== localEditNoteValue.trim()

    if (edited) {
      setConfirmExitPopupCloseAction({ close: () => setAnchor(null) })
      return false
    }

    setAnchor(null)

    return true
  }

  const handleSubmit = (note: string, cb: () => void) => {
    if (profileNoteData?.profileId && profileNoteData?.note !== note) {
      updateNote({ id: profileNoteData?.profileId, data: { note: note.trim() } })
    } else {
      setAnchor(null)
    }

    // slight delay to let ui react before clearing the field
    setTimeout(cb, 400)
  }
  return (
    anchor && (
      <CustomPopover id="note_shortlist_profile_popover" anchor={anchor} setAnchor={handleClose}>
        <PopoverInner width={290}>
          <InputWithTitleSection
            multiline
            allowEmpty
            maxLength={100}
            onChange={val => setLocalEditNoteValue(val.trim())}
            initialValue={profileNoteData?.note}
            title={t(profileNoteData?.note ? translationKeys.EDIT_NOTE : translationKeys.ADD_NOTE)}
            label={t(translationKeys.ADD_NOTE_HERE)}
            onCancel={handleClose}
            middleButtonText={profileNoteData?.note ? (t(translationKeys.DELETE_NOTE) as string) : ''}
            middleButtonOnClick={deleteNoteHandler}
            submitButtonText={t(translationKeys.SAVE) as string}
            onSubmit={handleSubmit}
          />
        </PopoverInner>
      </CustomPopover>
    )
  )
}

export default memo(EditNotePopover)
